import { type CertificateTemplatesSortOption } from '@components';
import { ItemTypeEnum } from '@share/common-types';
import { IconDefinition, faBuilding, faHouse, faShip } from '@fortawesome/free-solid-svg-icons';

export const CATALOG_PAGE_SIZE = 10;

/** Query param used when opening catalog from image carousel (e.g. ?itemType=Cruise). */
export const CATALOG_ITEM_TYPE_PARAM = 'itemType';

export const SKELETON_CARD_COUNT = 10;

export const SORT_OPTIONS_CONFIG: { value: CertificateTemplatesSortOption; labelId: string }[] = [
  { value: 'priceAsc', labelId: 'certificates.catalog.sort.priceAsc' },
  { value: 'priceDesc', labelId: 'certificates.catalog.sort.priceDesc' },
];

export const ITEM_TYPE_OPTIONS: {
  key: 'all' | ItemTypeEnum;
  labelId: string;
  value: ItemTypeEnum[];
  icon?: IconDefinition;
}[] = [
  { key: 'all', labelId: 'certificates.catalog.filter.all', value: [] },
  {
    key: ItemTypeEnum.Condo,
    labelId: 'certificates.catalog.filter.condo',
    value: [ItemTypeEnum.Condo],
    icon: faHouse,
  },
  {
    key: ItemTypeEnum.Hotel,
    labelId: 'certificates.catalog.filter.hotel',
    value: [ItemTypeEnum.Hotel],
    icon: faBuilding,
  },
  {
    key: ItemTypeEnum.Cruise,
    labelId: 'certificates.catalog.filter.cruise',
    value: [ItemTypeEnum.Cruise],
    icon: faShip,
  },
];
